import React from "react";
import styled from "styled-components";

/**
 * 
 * @param {string} width Set width of scroll container 
 * @param {string} height Container will become scrollable when element height is greater than height specified
 * @param {Component} children Content
 * @returns {Component}
 */
export default function ScrollEffect({ width, height, children }) {
  return (
    <ScrollContainer width={width} height={height}>
      {children}
    </ScrollContainer>
  );
}

const ScrollContainer = styled.div`
  position: relative;
  display: grid;
  max-height: ${(props) => props.height || "auto"};
  width: ${(props) => props.width || "100%"};
  overflow: auto;

  /* Prevent scroll event to bubble out to parent container */
  overscroll-behavior: contain;

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: rgb(217, 217, 217);
    overflow: auto;
  }

  &::-webkit-scrollbar-thumb {
    overflow: auto;
    background-color: #707070;
    border-radius: 4px;
  }
`;
